import React from "react";
import styled from "styled-components";
import FlexBox from "./FlexBox";
import Text from "./Text";
import { ACCENT_800 } from "./colors";
import useMobileView from "../../hooks/useMobileView";

const TopToolTip = styled(FlexBox)`
  right: ${props => (props.offset ? "-0.5rem" : "-4.3rem")};
  z-index: 10;
  position: absolute;
  bottom: calc(-100% - 3rem);
`;

const TopArrow = styled(FlexBox)`
  right: ${props => (props.offset ? "5%" : "42%")};
  z-index: 11;
  top: -1.65rem;
  border-top: 0;
  width: 0.75rem;
  height: 0.75rem;
  border-right: 0;
  border-left: 1px;
  border-bottom: 1px;
  position: absolute;
  margin-top: 1.25rem;
  background-color: ${ACCENT_800};
  transform: translateX(-50%) rotate(135deg);
`;

const ToolTipContainer = styled(FlexBox)`
  padding: 0.5rem;
  width: 10rem;
  row-gap: 0.5rem;
  border-radius: 0.5rem;
  flex-direction: column;
  background-color: ${ACCENT_800};
`;

const CustomTooltip = ({ text, offset }) => {
  const isMobileView = useMobileView();

  // Hide tool tips for mobile view
  if (isMobileView) {
    return null;
  }

  return (
    <TopToolTip offset={offset}>
      <ToolTipContainer>
        <TopArrow offset={offset} />
        <Text
          color="white"
          bold
          fontSize="0.75rem"
          textAlign="center"
          lineHeight="1.25rem"
        >
          {text}
        </Text>
      </ToolTipContainer>
    </TopToolTip>
  );
};

export default CustomTooltip;
